import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'x-company-id': environment.companyId }),
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<any> {
    return this.http
      .post(
        environment.apiUrl + 'admin/auth/signin',
        {
          username,
          password,
        },
        httpOptions
      )
      .pipe(map((result) => result));
  }

  register(username: string, fullname: string, email: string, password: string): Observable<any> {
    return this.http.post(
      environment.apiUrl + 'admin/auth/signup',
      {
        username,
        email,
        fullname,
        password,
      },
      httpOptions
    );
  }
}
